import { Product } from '@shared/types/product';
import { Product as CsvProduct } from '@/components/organisms/quick-order/types';

export const ROOT_CODE_KEY = 'root-code';
export const mapCsvProduct = (product: Product): CsvProduct => {
  const variant = product.variants[0];
  const attributes = variant.attributes;
  const productStock = variant.availableQuantity;
  const rootCategoryId = product.categories?.length ? product.categories[0].rootCategoryId : '';
  const packaging = attributes?.packaging;
  const unitPrice = variant.price?.unitPrice;
  const fractionDigits = variant.price?.fractionDigits ?? 2;
  const unitPriceWithFractionDigit = (unitPrice ?? 0) / Math.pow(10, fractionDigits);
  const rootCode = attributes?.[ROOT_CODE_KEY];

  return {
    family: rootCategoryId ?? '',
    productKey: product.productKey,
    name: product.name,
    status: product.visibilityStatus ?? '',
    sku: product.variants[0].sku,
    rootCode,
    packaging: Number(packaging) ?? 1,
    unitPrice: unitPriceWithFractionDigit.toLocaleString('fr-FR', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }),
    quantity: 0,
    stock: productStock ?? 0,
  } as CsvProduct;
};
